var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "30px",
    viewBox: "0 0 44 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8FC85A79-9EA7-4C75-9322-DB9802B537B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.0-Mojo-SignUp",
    transform: "translate(-1064.000000, -317.000000)",
    stroke: "#0964DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(980.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-multi-icon",
    transform: "translate(85.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(35.500000, 10.500000) scale(-1, 1) translate(-35.500000, -10.500000) translate(29.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    x: 4.2,
    y: 1,
    width: 7,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91982396,20.5714286 C7.31505146,20.5714286 6.88653254,20.5714286 6.6342672,20.5714286 C6.10926801,20.5714286 5.68074909,20.5714286 5.34871044,20.5714286 C4.77735188,20.5714286 3.92031404,20.5714286 2.77759692,20.5714286 C1.3540252,20.5714286 0.2,19.4201539 0.2,17.9999963 C0.2,17.677474 0.260819602,17.3578304 0.379285801,17.0577414 C1.82317446,13.4001995 4.33668718,11.5714286 7.91982396,11.5714286 C9.57470982,11.5714286 11.0014352,11.961522 12.2,12.7417088",
    id: "Path",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    x: 4.2,
    y: 1,
    width: 7,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91982396,20.5714286 C7.31505146,20.5714286 6.88653254,20.5714286 6.6342672,20.5714286 C6.10926801,20.5714286 5.68074909,20.5714286 5.34871044,20.5714286 C4.77735188,20.5714286 3.92031404,20.5714286 2.77759692,20.5714286 C1.3540252,20.5714286 0.2,19.4201539 0.2,17.9999963 C0.2,17.677474 0.260819602,17.3578304 0.379285801,17.0577414 C1.82317446,13.4001995 4.33668718,11.5714286 7.91982396,11.5714286 C9.57470982,11.5714286 11.0014352,11.961522 12.2,12.7417088",
    id: "Path",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    x: 17,
    y: 6,
    width: 8,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9994707,18 C18.6575895,18 16.6631312,18.6006397 15.026903,19.8319716 C13.3600341,21.086362 12.0723277,22.9795888 11.1296133,25.4840725 C11.0194022,25.7768674 10.9629392,26.0871496 10.9629392,26.4 C10.9629392,27.1179685 11.2539535,27.767967 11.7244597,28.238474 C12.1949668,28.7089819 12.8449664,28.9999978 13.5629362,29 L28.4360061,29 C28.7488553,29 29.0591363,28.9435373 29.3519302,28.8333268 C30.0238717,28.5804013 30.5296821,28.0790621 30.8042771,27.4729688 C31.0788731,26.8668734 31.1222524,26.1560231 30.86933,25.4840779 C29.926618,22.979596 28.6389114,21.0863664 26.9720417,19.8319742 C25.3358129,18.6006405 23.3413534,18 20.9994707,18 Z",
    id: "Rectangle-12-Copy"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUserIcon);
export default __webpack_public_path__ + "static/media/multi-user-icon.c39c7cd602ca0f21d70f67a4bfe4f3db.svg";
export { ForwardRef as ReactComponent };